module.exports = __webpack_public_path__ + "static/media/avaliacaoFormativaIcon.ffb4e348.svg";